import {connect} from "react-redux";
import ActionsList from './ActionsList';
import * as selectors from '../selectors';

const {getBusinessCard , getCardActions } = selectors;

const mapStateToProps = (state) => {
    return {
        actions: getCardActions(state),
        actionsColor: getBusinessCard(state).settings.actionsSettings.color,
        fontColor: getBusinessCard(state).settings.actionsSettings.fontColor
    }
}

export default connect(mapStateToProps,null)(ActionsList);